<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="[
            'baodanData.startdata',
            { rules: [{ required: true, message: '请选择起始日期！' }] },
          ]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled
          placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" @change="handleName('name')" v-decorator="[
            'applicantInfo.name',
            { rules: [{ required: true, message: '请输入投保企业名称' }] },
          ]" placeholder="请输入投保企业名称" @blur="queryCompanyCodeByName"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select :disabled="disabledAll" @change="(value) => handleChange(value, 'idType')" v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [
                    { required: true, message: '请选择投保企业证件类型' },
                  ],
                },
              ]" placeholder="请选择投保企业证件类型">
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
            <a-input v-model="applicantInfo.idNumber" :disabled="disabledAll" v-decorator="[
                'applicantInfo.idNumber',
                {
                  rules: [
                    { required: true, message: '请输入投保企业证件号码' },
                  ],
                },
              ]" placeholder="请输入投保企业证件号码"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="行业类别">
            <a-cascader :options="industryList" :disabled="disabledAll" :field-names="{ label: 'text' }"
              :show-search="{ filter }" @change="
                (value, label) => handleChange(value, 'industrycode', label)
              " :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" v-decorator="[
                'applicantInfo.industrycode',
                { rules: [{ required: true, message: '请选择' }] },
              ]" placeholder="请选择行业" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader placeholder="请选择" :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)" v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]" :options="addressOptions" :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" style="float: left; width: 250px" />
          </a-col>
          <a-col :span="12">
            <a-input v-model="applicantInfo.detailaddress" :disabled="disabledAll" v-decorator="[
                'applicantInfo.detailaddress',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]" placeholder="请输入联系地址" style="float: left; width: 350px; margin-left: 10px"></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input v-model="applicantInfo.contactsname" :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]" placeholder="请输入联系人姓名"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input v-model="applicantInfo.contactsphone" :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [{ required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }],
                },
              ]" placeholder="请输入联系人电话"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input v-model="applicantInfo.email" :disabled="disabledAll" v-decorator="[
                'applicantInfo.email',
                {
                  rules: [{ required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }],
                },
              ]" placeholder="请输入联系人邮箱"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select @change="(value) => handleChange(value, 'payMethod')" 
              style="width: 100%" placeholder="请选择支付类型" :disabled="disabledAll" v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }],
                },
              ]">
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- <a-row :gutter="24">
        <a-form-item :label-col="{ span: 3 }" label="保单备注" style="padding: 0 12px">
          <a-input :disabled="disabledAll" style="width: 100%" v-model="applicantInfo.remark"
            v-decorator="['applicantInfo.remark']" placeholder="请输入保单备注"></a-input>
        </a-form-item>
      </a-row> -->
      <salInsuredList :disabledAll="disabledAll" :columns="columns" :data="data" @delSelect="delSelectpre"
        @addSelect="addSelectpre" @EduitSelect="EduitSelect"></salInsuredList>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
          <a-col>
            <a-button class="btn_color" :disabled="disabledAll" type="primary" @click="changePremium">
              修改保费
            </a-button>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox @change="onChangeyueduBtn" :disabled="!agreementAllRead" style="margin-bottom:20px">
          投保人已充分阅读、理解并同意 <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll"
              @click="handleSubmit">
              保存订单
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll"
              @click="fastInsure">
              立即投保
            </a-button>
<!-- @click="fastInsure('1')"> -->
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">
              编辑
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in copyCScontent" :key="key">
        <div v-if="ContentView[key] > 0">
          请输入职业{{ key }}类保费(如不输入则按原值({{
            ContentView[key]
          }})计算)：
          <a-input-number class="level_" :min="parseFloat(ContentView[key])" v-model="copyCScontent[key]" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定"
      cancelText="关闭">
      <p style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        ">
        您投保的{{ productName() }}需支付保费
        <span style="color: #fe8f2d; font-weight: bold">{{
          applicantInfo.totalPremium
        }}</span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  // import Vue from 'vue'
  import moment from "moment";
  import salInsuredList from "./salInsuredList";
  import { policyMixin } from '@/mixins/policyMixin.js';
  let DATA = require('../data').default;
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: { salInsuredList },
    mixins: [policyMixin],
    data() {
      //这里存放数据
      return {
        yueduBtn: false,
        saveBtnShow: false, //保存过
        submitLoad1: false, //保存中
        showPaySure: false, //支付
        postPolicyData: {}, //要提交的数据
        policyId: "", //支付回来的id
        checkVisible: false, //凭证支付
        showQrcodePayModal: false, // 二维码支付
        /**需要的数据开始 */
        applicantInfo: {
          name: "", //投保企业名称
          idType: "", //证件类型
          idNumber: "", //证件号码
          pacCode: "", //省市区
          address: "", //省市区中文
          detailaddress: "", //详细地址
          industrycode: "", //行业类别
          contactsname: "", //联系人名称
          contactsphone: "", //联系人电话
          email: "", // 邮箱
          vehicleown: "", // 投保人行业名称
          engineno: "", // 企业性质名称
          remark: 1, //保单备注
          payMethod: "", //支付类型
          totalPremium: 0, //总保费
          expireDate: "", //保单终止时间
          effectiveDate: "", // 保单生效时间
          mon: 12, //保证期限
        },
        //表格的头部
        columns: DATA.columns,
        //表格的数据
        data: [],
        rate: 0.2, //费率
        industrycodeTEXT: "", //四级行业的文本
        mobilestringcode: "0;0;0;0;0", //每一类添加的保费
        maxType: 1, //最大类别
        companyCode: "01", //企业性质
        planinfos: "0;0;0", //基础保费
        perRiskInfo: "", //险种类
        evidenceNumber: "", //凭证号
        riskNumber: {}, //计算保费
        uniqueArr: [], //去重后的人数列表
        //投保人证件类型
        companyIdTypeOptions: [
          {
            value: "1",
            name: "组织机构代码证",
          },
          {
            value: "4",
            name: "营业执照",
          },
        ],
        loading: false,
        form: this.$form.createForm(this, { name: "advanced_search" }),
        RiskInfos: {
          riskInfos: [
            {
              riskCode: "10", //工伤死亡伤残
              dutyCode: "631001",
              amount: 100000,
              premiumAmt: 0,
              riskName: `工伤死亡伤残`,
              riskAmountDesc: 100000,
            },
            {
              riskCode: "11", //工伤事故医疗费用（0免赔100%赔付）
              dutyCode: "631002",
              amount: 0,
              premiumAmt: 0,
              riskName: `工伤事故医疗费用（0免赔100%赔付）`,
              riskAmountDesc: 0,
            },
            {
              riskCode: "55", //扩展社保外医疗费用（含甲乙丙类自付和自费）
              dutyCode: "631002",
              amount: 0,
              premiumAmt: 0,
              riskName: `扩展社保外医疗费用（含甲乙丙类自付和自费）`,
              riskAmountDesc: 0,
            },
            {
              riskCode: "33", //误工费
              dutyCode: "631042",
              amount: 100,
              premiumAmt: 0,
              riskName: `误工费`,
              riskAmountDesc: `100元/天`,
            },
            {
              riskCode: "44", //附加24小时意外扩展条款
              dutyCode: "631057",
              amount: 0,
              premiumAmt: 0,
              riskName: `附加24小时意外扩展条款`,
              riskAmountDesc: "附加24小时意外扩展条款",
            },
            {
              riskCode: "100", //工伤伤残赔付高标准（附加提升伤残比例）
              dutyCode: "631006",
              amount: 0,
              premiumAmt: 0,
              riskName: `工伤伤残赔付高标准（附加提升伤残比例）`,
              riskAmountDesc: 0,
            },
          ],
          salPolicy: {
            productCode: "", //产品code
            planCode: "",
            groupSize: 0, //人数
            creator: "", //用户id
            bracket: 12, //保费期限
            totalPremium: 0, //总保费
            coverageamount: 0, //总保额
          },
          salPolicyExt: {
            isworkheightinvolved: 2,
            occEmpVersion: 0,
            occuRiskPremium: null,
          },
          salPolicyHolder: {
            addfifty: "2", // 测算类型
            name: "", //被保人名称
            stature: 2, //是否高空（2-否，1-是）
            vehicleown: "", // 投保人行业名称
            engineno: "", // 企业性质名称
          },
          premiumBaseDtoList: [], //人数
        }, //测算的数据
        modalVisible: false, //修改保费的弹窗
        CScontent: {},
        ContentView: {}, //展示的保费
        copyCScontent: {}, //拷贝的
        creator: "1",
        productCode: "",
        plan: "",
        userParams: "",
        /**需要的数据结束 */
        guapre: 1,
        planOffsetDay: 0,
        baodanData: {
          startdata: "",
        },
        startValues: null,
        linshiContent: {},
        riskInfosAmount: {}, //计算险种的结果
        ZBAOFEI: 0, //原始保费
        addBAOFEI: 0, //修改添加的保费
        orderContent: {}, //订单的数据
        disabledAll: false, //是否是立即投保
        gztypestr: "",
      };
    },
    //监听属性 类似于data概念
    computed: {
      //行业类别
      industryList() {
        let indust = window.gybhycode;
        indust.forEach((e) => {
          return e.children.filter((el) => {
            return el;
          });
        });
        return indust;
      },
      addressOptions() {
        let oneArrcode = '130000 120000 990000 220000 230000'
        let twoArrCode = "211200 131000 411500 320400 320700 371600 371400 371300 411500 410800 410700 511500 511800 350700 421100";
        let threeArrCode = "320581 320582 320583 110116 110117 110118 131082 120116 120118 370683 130321 371482 410425 421181";
        let dataArr = window.addrescode
        dataArr && dataArr.forEach(e => {
          if (oneArrcode.indexOf(e.value) > -1) {
            e['disabled'] = true
          }
          if (e.children && e.children.length) {
            e.children.forEach(el => {
              if (twoArrCode.indexOf(el.value) > -1) {
                el['disabled'] = true
              }
              if (el.children && el.children.length) {
                el.children.forEach(ele => {
                  if (threeArrCode.indexOf(ele.value) > -1) {
                    ele['disabled'] = true
                  }
                });
              }
            });
          }
        });
        return dataArr;
      },
      applicantInfoExpireDate() {
        var mon = this.applicantInfo.mon;
        var date = this.applicantInfo.effectiveDate;
        let t2
        if (date && mon) {
          t2 = moment(date).add(mon, 'months').subtract(1, 's')
        }
        return t2;
      },
    },
    //方法集合
    methods: {
      moment,
      productName() {
        return sessionStorage.getItem('productName')
      },
      gonOne() {
        this.disabledAll = false;
        this.addBAOFEI = this.$accuracy.sub(
          this.applicantInfo.totalPremium,
          this.ZBAOFEI
        );
        this.$bus.$emit("disabledBus", false);
        this.$router.push({
          name: "gybgz",
          query: {
            u: this.$route.query.u,
            p: this.$route.query.p,
            sign: this.$route.query.sign,
            planCode: this.$route.query.planCode
          },
        });
      },
      handleName() {
        if (this.data.length) {
          this.resultPremiumSum(this.RiskInfos);
        } else {
          this.applicantInfo.totalPremium = 0;
        }
      },
      queryOrderDetails() {
        // 查询保单信息
        let parms = {
          policyId: this.$route.query.policyId,
        };
        this.$api
          .queryOrderDetails(parms)
          .then((res) => {
            if (res.data.returnCode == 0) {
              if (res.data.content) {
                this.orderContent = res.data.content;
                this.$store.commit("setOrderContent", this.orderContent);
                // console.log(res, "这里是国富的添加订单管理接口");
                if (res.data.content.salInsuredList) {
                  //被保人清单
                  this.data = res.data.content.salInsuredList;
                  this.data.forEach((element, i) => {
                    let str = element.birthDate;
                    element.occupation = [
                      element.occupationCode.substring(0, 3),
                      element.occupationCode.substring(0, 4),
                      element.occupationCode,
                    ]; //职业类别代码
                    element["index"] = i + 1;
                    element.birthDate = str.replace(/\//g, "-"); //生日
                  });
                }
                if (res.data.content.riskInfos) {
                  let riskInfos = res.data.content.riskInfos;
                  this.$bus.$emit("busRiskInfos", riskInfos);
                }
                if (res.data.content.salPolicy) {
                  let salPolicy = res.data.content.salPolicy;
                  this.RiskInfos.salPolicy.coverageamount =
                    salPolicy.coverageamount;
                  this.policyId = salPolicy.id.toString();
                  this.plan = salPolicy.planCode;
                  this.applicantInfo.mon = parseInt(salPolicy.bracket);
                  this.applicantInfo.totalPremium = salPolicy.totalPremium;
                  this.applicantInfo.payMethod = salPolicy.payMethod;
                  this.creator = salPolicy.creator;
                  this.productCode = salPolicy.productCode;
                  this.$store.commit("setproductCode", this.productCode);
                  let effectiveDate;
                  if (this.$route.query.xb) {
                    //续保情况下时间处理
                    effectiveDate = moment(salPolicy.expireDate).add(1, "days");
                  } else {
                    effectiveDate = moment(salPolicy.effectiveDate);
                  }
                  this.applicantInfo.effectiveDate = moment(
                    effectiveDate
                  ).format("YYYY-MM-DD");
                  this.baodanData.startdata = this.applicantInfo.effectiveDate;
                  this.form.setFieldsValue({
                    applicantInfo: {
                      ...salPolicy,
                      effectiveDate: moment(effectiveDate).format(
                        "YYYY-MM-DD"
                      ),
                    },
                    baodanData: {
                      startdata: moment(effectiveDate).format(
                        "YYYY-MM-DD"
                      ),
                    },
                  });
                }
                if (res.data.content.salPolicyHolder) {
                  let salPolicyHolder = res.data.content.salPolicyHolder;
                  this.applicantInfo.name = salPolicyHolder.name;
                  this.mobilestringcode = salPolicyHolder.mobilestringcode;
                  // this.applicantInfo.companytype = salPolicyHolder.companytype;
                  this.applicantInfo.industrycode = [
                    salPolicyHolder.industrycode.slice(0, 1),
                    salPolicyHolder.industrycode.slice(0, 3),
                    salPolicyHolder.industrycode.slice(0, 4),
                    salPolicyHolder.industrycode,
                  ];
                  this.applicantInfo.detailaddress =
                    salPolicyHolder.detailaddress;
                  this.applicantInfo.vehicleown = salPolicyHolder.vehicleown;
                  this.applicantInfo.engineno = salPolicyHolder.engineno;
                  this.applicantInfo.address = salPolicyHolder.address;
                  this.applicantInfo.pacCode = this.filterPcode(
                    [
                      salPolicyHolder.province,
                      salPolicyHolder.city,
                      salPolicyHolder.district,
                    ] || []
                  ).arrCode;

                  this.gztypestr = res.data.content.salPolicyHolder.gztypestr;
                  this.copyCScontent = this.Filtergztypestr(this.gztypestr);
                  this.CScontent = this.Filtergztypestr(this.gztypestr);
                  this.form.setFieldsValue({
                    applicantInfo: {
                      ...salPolicyHolder,
                      pacCode: this.filterPcode(
                        [
                          salPolicyHolder.province,
                          salPolicyHolder.city,
                          salPolicyHolder.district,
                        ] || []
                      ).code,
                      industrycode: [
                        salPolicyHolder.industrycode.slice(0, 1),
                        salPolicyHolder.industrycode.slice(0, 3),
                        salPolicyHolder.industrycode.slice(0, 4),
                        salPolicyHolder.industrycode,
                      ],
                      idType: salPolicyHolder.idType,
                    },
                  });
                }
                if (res.data.content.salPolicyExt) {
                  this.RiskInfos.salPolicyExt.occuRiskPremium =
                    res.data.content.salPolicyExt.occuRiskPremium;
                  this.RiskInfos.salPolicyExt.isworkheightinvolved = res.data
                    .content.salPolicyExt.isworkheightinvolved
                    ? res.data.content.salPolicyExt.isworkheightinvolved
                    : "2";
                  this.RiskInfos.salPolicyExt.occEmpVersion =
                    res.data.content.salPolicyExt.occEmpVersion;
                  this.$bus.$emit("salPolicyExt", res.data.content.salPolicyExt);
                }
                // debugger
                this.data = res.data.content.salInsuredList;
                this.riskNumber = this.countTimes(this.data);
                this.RiskInfos.premiumBaseDtoList = this.numResult(
                  res.data.content.salInsuredList
                ); //人员类别，处理成每一类的人数
                this.RiskInfos.salPolicy = {
                  ...this.RiskInfos.salPolicy,
                  ...res.data.content.salPolicy
                };
                this.RiskInfos.salPolicyHolder = {
                  ...this.RiskInfos.salPolicyHolder,
                  ...res.data.content.salPolicyHolder
                };
                // debugger
                this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
                this.resultPremiumSum(this.RiskInfos, "eduit");
              }
            }
          })
      },
      filterPcode(arr) {
        let str;
        if (arr && arr.length) {
          if (isNaN(parseInt(arr[0]))) {
            str = 'text'
          } else {
            str = 'value'
          }
          if (!str) return
          try {
            var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
            var oneArr = addressOptions.filter((item) => arr[0] == item[str]) || [];
            var twoArr =
              oneArr[0].children.filter((item) => arr[1] == item[str]) || [];
            var threeArr =
              twoArr[0].children&&twoArr[0].children.filter((item) => item[str] == arr[2]) || [];
            sessionStorage.setItem("pacCode", threeArr[0]&&threeArr[0].value);
          } catch (error) {
            throw new Error(error);
          }
          return {
            code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
            arrCode: [oneArr[0], twoArr[0], threeArr[0]],
          };
        }
      },
      Filtergztypestr(data) {
        let newData = data.split(";").slice(8, -1);
        let obj = {};
        newData.forEach((e, i) => {
          obj[i + 1] = e;
        });
        return obj;
      },
      //确认修改
      handleOk() {
        let numResult = 0;
        // debugger
        let sumZfeiyong = this.sumZfeiyong(this.copyCScontent, this.riskNumber);
        console.log(sumZfeiyong, "777=================");
        Object.values(sumZfeiyong).forEach((e) => {
          numResult += e;
        });
        console.log(numResult, "总保费===================");
        this.addBAOFEI = this.$accuracy.sub(numResult, this.ZBAOFEI);
        this.applicantInfo.totalPremium = numResult.toFixed(2);
        this.CScontent = this.copyCScontent;
        this.modalVisible = false;
        this.gztypestr = "";
        this.Eachbaofei(this.ContentView, this.CScontent);
      },
      //每一类添加的保费
      Eachbaofei(val, newVal) {
        // debugger
        let num1 = this.$accuracy.sub(Number(newVal[1]), Number(val[1])) || 0;
        let num2 = this.$accuracy.sub(Number(newVal[2]), Number(val[2])) || 0;
        let num3 = this.$accuracy.sub(Number(newVal[3]), Number(val[3])) || 0;
        let num4 = this.$accuracy.sub(Number(newVal[4]), Number(val[4])) || 0;
        this.mobilestringcode = [num1, num2, num3, num4].join(";");
      },
      //修改保费
      changePremium() {
        if (JSON.stringify(this.CScontent) == "{}") {
          this.$message.error("您还没有计算保费");
          return;
        }
        this.modalVisible = true;
      },
      //反转对象
      resoverObj(obj) {
        var a = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        };
        for (const key in obj) {
          a[key] = obj[key];
        }
        return a;
      },
      //统计次数
      numResult(data) {
        // debugger
        console.log(data);
        var d = [];
        var b = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        };
        data.forEach((e) => {
          let levelF = Number(e.occulevel.toString().slice(0, 1));
          if (b[levelF] !== undefined) {
            b[levelF] += 1;
          }
        });
        for (const key in b) {
          var c = {
            occupationKind: "",
            personNum: 0,
          };
          c.occupationKind = key;
          c.personNum = b[key];
          d.push(c);
        }
        console.log(d);
        return d;
      },
      //处理险种的拼接字段
      perRiskInfoNew(perRiskInfo) {
        var arrperRiskInfo = [];
        perRiskInfo.forEach((e) => {
          if (e.riskCode == "GSSGCJ" && e.amount > 0) {
            arrperRiskInfo.push(
              "10-工伤身故、残疾-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "GSSGYL" && e.amount > 0) {
            arrperRiskInfo.push(
              "11-工伤事故医疗费用-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "TZSBFWW" && e.amount > 0) {
            arrperRiskInfo.push(
              "55-扩展社保范围外医疗费用-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "24HYWXTB" && e.amount > 0) {
            arrperRiskInfo.push(
              "44-24小时意外险特别扩展条款-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "YWZYJTMC" && e.amount > 0) {
            arrperRiskInfo.push(
              "22-意外住院津贴每次事故-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "WGF" && e.amount > 0) {
            arrperRiskInfo.push("33-误工费-" + e.amount + "-" + e.premiumAmt);
          }
          if (e.riskCode == "YCXSCJY" && e.amount > 0) {
            arrperRiskInfo.push(
              "66-一次性伤残就业补助金-" + e.amount + "-" + e.premiumAmt
            );
          }
          if (e.riskCode == "SHHLF" && e.amount > 0) {
            arrperRiskInfo.push("77-生活护理费-" + e.amount + "-" + e.premiumAmt);
          }
          if (e.riskCode == "GSDCGPF" && e.amount > 0) {
            arrperRiskInfo.push(
              "100-工伤定残高赔付标准-" + e.amount + "-" + e.premiumAmt
            );
          }
        });
        console.log(arrperRiskInfo);
        return arrperRiskInfo.join("#");
      },
      filter(inputValue, path) {
        return path.some((option) => {
          return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        });
      },
      //测算的总价格
      cesuannum(data) {
        var a = {};
        var resultnum = 0;
        this.RiskInfos.premiumBaseDtoList.forEach((e) => {
          a[e.occupationKind] = e.personNum;
        });
        for (const key in a) {
          console.log(key);
          resultnum += a[key] * data[key];
        }
        console.log(resultnum, "总保费");
        return resultnum.toFixed(2);
      },
      //试算的接口
      resultPremiumSum(data, type) {
        console.log(data, "计算的参数");
        // return
        let copyData = this.$lodash.cloneDeep(data);
        copyData.premiumBaseDtoList.forEach((e) => {
          e.occupationKind = Number(e.occupationKind.toString().slice(0, 1));
        });
        console.log(copyData);
        let formData = {
          riskInfos: copyData.riskInfos.filter((item) => item.amount > 0), //险种信息
          salPolicy: {
            planCode: this.plan, //产品计划 （固定值ConstructAccident）
            productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
            creator: this.creator,
            bracket: copyData.salPolicy.bracket, //保费期限
            groupSize: this.data.length || 0,
          },
          salPolicyExt: {
            isworkheightinvolved: copyData.salPolicyHolder.stature,
            occEmpVersion: this.fileCodeContent.id,
          },
          salPolicyHolder: {
            addfifty: "2", // 测算类型
            stature: copyData.salPolicyHolder.stature, //是否高空（2-否，1-是）
            // name: this.applicantInfo.name,
          },
          premiumBaseDtoList: copyData.premiumBaseDtoList.filter(
            (item) => item.personNum > 0
          ), //人数
        };
        console.log(formData);
        // return
        this.$api.calPremiumEmployer(formData).then((res) => {
          if (res.data.success) {
            let datas = JSON.parse(res.data.content);
            this.riskInfosAmount = datas;
            type == "eduit" ? "" : (this.gztypestr = "");
            let showContent = this.$lodash.cloneDeep(datas.occuLevelSingalPrem);
            this.ContentView = showContent; //文案展示保费，恒定不变，做限制
            this.RiskInfos.salPolicy.coverageamount = datas.coverageamount;
            if (type != "eduit") {
              this.CScontent = datas.occuLevelSingalPrem;
              this.copyCScontent = this.resoverObj(this.$lodash.cloneDeep(this.ContentView)); //修改，最后复制的对象
            }
            if (!this.disabledAll) {
              this.applicantInfo.totalPremium = datas.totalPremium; //总保费
            }
            this.ZBAOFEI = this.$lodash.cloneDeep(datas.totalPremium);
            this.RiskInfos.salPolicyExt.occuRiskPremium = JSON.stringify(
              datas.occuLevelDutyPremium
            );
          } else {
            this.$message.error(res.data.returnMsg + "错误");
          }
        });
      },
      //选择天数的
      onChangemon(e) {
        // debugger
        console.log(e);
        this.applicantInfo.mon = e.target.value;
        this.RiskInfos.salPolicy.bracket = this.applicantInfo.mon;
        if (this.RiskInfos.premiumBaseDtoList.length) {
          this.resultPremiumSum(this.RiskInfos);
        }
        if (this.applicantInfo.effectiveDate) {
          let end = moment(this.startValues)
            .add(this.applicantInfo.mon, "month")
            .subtract(1, "days");
          let offsetDay = end.diff(this.startValues, "days") + 1;
          this.planOffsetDay = offsetDay;
          this.form.setFieldsValue({ expireDate: end });
        }
      },
      //处理时间的
      effectiveDateChange(date1, date) {
        this.applicantInfo.effectiveDate = date;
      },
      //开始时间
      disabledDate(current) {
        var dd = new Date();
        dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
        var time = y + "-" + m + "-" + d;
        var currents = moment(time);
        return current && current < currents;
      },
      //修改
      EduitSelect(data) {
        console.log(data, "传过来的数据");
        // debugger
        this.data.forEach((e, i) => {
          if (i == data.eduitIndex) {
            this.data[i] = data;
          }
          if (e.occulevel.toString().indexOf("类") <= -1) {
            e.occulevel = e.occulevel + "类";
          }
        });
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        console.log(this.riskNumber, "人数");
        this.resultPremiumSum(this.RiskInfos);
        console.log(this.data, "添加后的");
      },
      //粘贴
      addSelectpre(data) {
        if (Array.isArray(data)) {
          this.data.push(...data);
        } else {
          this.data.push(data);
        }
        let cesiData = this.$lodash.cloneDeep(this.data);
        this.data = this.unique(this.data, "idNumber");
        if (cesiData.length != this.data.length) {
          this.$message.warning("受保人有重复，已做删除");
        }
        console.log(this.data, "添加数据");
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        console.log(this.riskNumber, "人数");
        this.resultPremiumSum(this.RiskInfos);
      },
      //批量删除
      delSelectpre(data) {
        this.data = data;
        let cesiData = JSON.parse(JSON.stringify(this.data));
        this.data = this.unique(this.data, "idNumber");
        if (cesiData.length != this.data.length) {
          this.$message.warning("受保人有重复，已做删除");
        }
        console.log(data, "删除数据");
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        console.log(this.riskNumber, "人数");
        if (this.data.length) {
          this.resultPremiumSum(this.RiskInfos);
        } else {
          this.applicantInfo.totalPremium = 0;
        }
      },
      //提交的去重
      unique(arr, attribute) {
        var new_arr = [];
        var json_arr = [];
        for (var i = 0; i < arr.length; i++) {
          if (new_arr.indexOf(arr[i][attribute]) == -1) {
            //  -1代表没有找到
            new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
            json_arr.push(arr[i]);
          }
        }
        return json_arr;
      },
      salInsuredList(data) {
        // debugger
        data.forEach((e) => {
          console.log(e);
          if (e["gender"] == '男' || e["gender"] == 'M') {
            e["gender"] = "M";
          } else {
            e["gender"] = "F";
          }
          let leiocc = Number(e.occulevel.toString().slice(0, 1))
          e["occulevel"] = Number(e.occulevel.toString().slice(0, 1));
          console.log(this.copyCScontent);
          e["premium"] = Number(this.copyCScontent[leiocc]);
        });
        return data;
      },
      //计算总保费
      countTimes(data) {
        var a = [];
        if (data.length) {
          data.forEach((e) => {
            let leve =
              e.occulevel.toString().indexOf("类") > -1
                ? Number(e.occulevel.toString().slice(0, 1))
                : Number(e.occulevel);
            a.push(leve);
          });
          return a.reduce(function (time, name) {
            if (name in time) {
              time[name]++;
            } else {
              time[name] = 1;
            }
            return time;
          }, {});
        } else {
          return {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
          };
        }
      },
      //计算总保费
      sumZfeiyong(content, riskNumber) {
        var jichu = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        };
        for (const key in content) {
          jichu[key] = content[key] * riskNumber[key] || 0;
        }
        console.log("jishu=======", jichu);
        return jichu;
      },
      //计算费率
      sumrate(isHighWork, data, bracket) {
        console.log(bracket, "期限");
        var a = [];
        data.forEach((e) => {
          a.push(e.occulevel.toString().slice(0, 1));
        });
        this.maxType = Math.max(...a);
        var is45 = a.some((val) => {
          return val == "4" || val == "5";
        });
        if (is45 || isHighWork == "1") {
          let rate = {
            1: 0.4,
            3: 0.4,
            6: 0.7,
            12: 1.0,
          };
          this.rate = rate[bracket];
        } else {
          let rate = {
            1: 0.2,
            3: 0.4,
            6: 0.7,
            12: 1.0,
          };
          this.rate = rate[bracket];
        }
      },
      //拼接gztypestr字段
      gztypestrPin() {
        var a = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        };
        delete this.CScontent["perRiskInfo"];
        console.log(this.CScontent, this.copyCScontent)
        for (const key in this.CScontent) {
          a[key] = this.CScontent[key];
        }
        let baofei = Object.values(a).join(";"); //总保费
        this.planinfos = Object.values(a).slice(0, 3).join(";"); //基础保费
        console.log(baofei, "===========总保费");
        let b = [];
        this.data.forEach((e) => {
          b.push(e.occulevel.toString().slice(0, 1));
        });
        this.maxType = Math.max(...b);
        var arr = [
          2,
          12,
          this.maxType,
          0, //费率
          this.industrycodeTEXT || "",
          this.applicantInfo.industrycode[3] || "",
          0,
          this.data.length || 0,
          baofei,
          this.applicantInfo.companytype || "1",
        ];
        console.log(arr, "拼接的字符串");
        return arr.join(";");
      },
      //计算数组之和
      sumarr(arr) {
        return Object.values(arr).reduce(function (prev, cur) {
          return this.$accuracy.add(Number(prev), Number(cur));
        });
      },
      //处理险种信息
      filterRiskInfo(data) {
        // debugger
        console.log(data, "处理前");
        data.forEach((e) => {
          if (e.dutyCode == "631001" && e.riskCode == "060099") {
            e.premiumAmt = this.$accuracy.add(
              Number(this.riskInfosAmount[e.dutyCode] || 0),
              this.addBAOFEI
            );
          } else {
            e.premiumAmt = this.riskInfosAmount[e.dutyCode] || 0;
          }
        });
        console.log(data, "处理后");
        return data.filter((item) => item.amount > 0);
      },
      //最后的提交
      handleSubmit() {
        let ageStatus = true;
        this.data.forEach((e) => {
          let age = moment().diff(e.birthDate, "years");
          if (age < 16 || age > 65) {
            this.$message.error("投保人年龄仅限于16-65周岁，请修改后再试！");
            ageStatus = false;
            return;
          }
        });
        if (!ageStatus) {
          return;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            let base = this.applicantInfo;
            let gztypestrPin = this.gztypestrPin();
            if (!gztypestrPin) {
              this.$message.warning("请先进行试算！");
              return;
            }
            if (this.data.length < 5) {
              this.$message.warning(
                "投保人须为团体，每张保单不少于5人投保，且需投保同一方案。"
              );
              return;
            }

            let UNname = "天津";
            if (UNname.indexOf(values.applicantInfo.name) > -1) {
              this.$message.warning("本产品不承保注册地或营业地在天津的企业。");
              return;
            }

            let UNnames = "铁塔架设 高压电力 井下深坑 海上 空中 采矿 石油开采 化工 枪弹炸药 船舶制造 核能";
            if (UNnames.indexOf(values.applicantInfo.name) > -1) {
              this.$message.warning("本保单不承保涉及铁塔架设、高压电力、井下深坑、海上、空中、采矿、石油开采、化工、枪弹炸药、船舶制造、核能的职业。");
              return;
            }

            let data = {
              salInsuredList: this.salInsuredList(this.data), //表格的数据
              salPolicy: {
                //保单信息
                planCode: this.plan, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                id: this.policyId,
                // issueDate: moment().format("YYYY-MM-DD HH:mm:ss"), //applyTime  投保时间（当前时间）
                effectiveDate: moment(values.baodanData.startdata).format(
                  "YYYY-MM-DD"
                ), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format(
                  "YYYY-MM-DD"
                ), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付类型”
                bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
                groupSize: this.data.legnth || 0, //投保人数
                totalPremium: base.totalPremium, //totalPremium  总保费
                remark: values.applicantInfo.remark, //备注
                ordertraceno: "", //"凭证支付时的凭证号",
                coverageamount: this.RiskInfos.salPolicy.coverageamount,
              },
              salPolicyExt: {
                isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //是否高空作业
                occEmpVersion: this.fileCodeContent.id,
                occuRiskPremium: this.RiskInfos.salPolicyExt.occuRiskPremium,
              },
              salPolicyHolderExt: {
                industryname: this.industrycodeTEXT,
              },
              salPolicyHolder: {
                //投保人信息
                planinfos: this.planinfos, //
                addfifty: this.RiskInfos.salPolicyHolder.addfifty, //测算类型
                type: "C", //固定值
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                address: this.applicantInfo.address, //省市区中文
                detailaddress: values.applicantInfo.detailaddress, //详细地址
                // companytype: values.applicantInfo.companytype, //企业性质
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                contactsphone: values.applicantInfo.contactsphone, //联系人电话
                telephone: values.applicantInfo.contactsphone, //联系人电话
                email: values.applicantInfo.email, //联系人邮箱
                vehicleown: this.applicantInfo.vehicleown, // 投保人行业名称
                engineno: this.applicantInfo.engineno, // 企业性质名称
                // beneficiary: values.applicantInfo.beneficiary, //附加被保险人
                industrycode: values.applicantInfo.industrycode[3], //行业类型
                province: base.pacCode[0].text, //省
                city: base.pacCode[1].text, //市
                district: base.pacCode[2]&&base.pacCode[2].text, //区
                addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2]&&base.pacCode[2].value}`,
                gztypestr: this.gztypestrPin(),
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                mobilestringcode: this.mobilestringcode, //每一类添加的保费
                // invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
                // taxpayercertificatetype:
                //   values.applicantInfo.invoiceprinttype == "01"
                //     ? values.applicantInfo.taxpayercertificateno
                //     : "01",
              },
              riskInfos: this.filterRiskInfo(this.RiskInfos.riskInfos, "eduit"),
              // riskInfos: this.RiskInfos.riskInfos.filter((item)=>item.amount>0)
            };
            this.postPolicyData = data;
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            this.$store.commit("setproductCode", this.productCode);
            this.submitLoad1 = true;
            this.axiosPolicy(); // 保存订单是 直接保存
          } else {
            this.$message.error("请填写完整提交的数据");
          }
        });
      },
      axiosPolicy() {
        //提交保单
        this.$api
          .addPAPolicy(this.postPolicyData)
          .then((res) => {
            if (res.data.returnCode == "00") {
              this.showPaySure = false;
              this.saveBtnShow = true;
              this.policyId = res.data.content;
              this.$message.success("保存成功！");
              this.$router.push({
                name: "gybgz",
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                  planCode: this.$route.query.p
                },
              });
              this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.submitLoad1 = false;
          });
      },
      paySure() {
        //支付确认
        this.showPaySure = false;
        this.submitLoad1 = false;
        this.submitLoad2 = false;
        this.policyId = this.$route.query.policyId;
        this.$payModal({
          show: true,
          type: "GYBGZ", //产品类型
          policyId: this.policyId, //产品id
          creator: this.creator, //用户id
          payMethod: this.applicantInfo.payMethod, //支付方式
          productCode: this.$route.query.p, //产品code
          totalPremium: this.applicantInfo.totalPremium, //支付总金额
          name: this.applicantInfo.name,
        });
      },
      handleChange(value, type, label) {
        if (type == "pacCode") {
          this.applicantInfo[type] = label;
          if (label) {
            this.applicantInfo.address =
              label.length > 2
                ? label[0].text + label[1].text + label[2].text
                : "";
          }
          sessionStorage.setItem("pacCode", value[2]);
        } else if (type == "industrycode") {
          sessionStorage.setItem("HYCode", value);
          this.industrycodeTEXT = label ? label[3].text : "";
          this.applicantInfo[type] = value;
        } else {
          this.applicantInfo[type] = value;
        }
        if(type == 'idType') {
          this.queryCompanyCodeByName()
        }
        // this.form.setFieldsValue({
        //   applicantInfo: {
        //     [type]: value,
        //   },
        // });
      },
      queryCompanyCodeByName() {
        if(!this.applicantInfo.idType) {
          return
        }
        let type = this.applicantInfo.idType == '1' ? 2 : 1
        this.blurCompanyName(type)
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      const {p } = this.$route.query;
      this.plan = p;
      this.$bus.$on("onRiskInfos", (data) => {
        let strdata = this.$lodash.cloneDeep(data);
        console.log(strdata, 4444444444444444);
        this.RiskInfos.riskInfos = strdata.riskInfos;
        this.RiskInfos.salPolicy = strdata.salPolicy;
        this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
        this.applicantInfo.mon = Number(strdata.salPolicy.bracket);
        this.applicantInfo.name = strdata.salPolicyHolder.name;
        this.form.setFieldsValue({
          applicantInfo: {
            name: strdata.salPolicyHolder.name,
          },
        });
        console.log(this.RiskInfos, "接受到的数据");
        if (this.RiskInfos.premiumBaseDtoList.length) {
          this.resultPremiumSum(this.RiskInfos);
        } else {
          this.applicantInfo.totalPremium = 0;
        }
      });
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() {
      this.$bus.$off("onRiskInfos");
      this.$bus.$off("CScontent");
    }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style scoped>
  .avatar-uploader>>>.ant-upload {
    width: 128px;
    height: 128px;
  }

  .avatar-uploader>>>.ant-upload img {
    width: 100%;
    height: 100%;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn_color {
    margin: 0 20px;
  }
</style>